import { render, staticRenderFns } from "./WhiteCardHome.vue?vue&type=template&id=18ff1522&scoped=true"
import script from "./WhiteCardHome.vue?vue&type=script&lang=js"
export * from "./WhiteCardHome.vue?vue&type=script&lang=js"
import style0 from "./WhiteCardHome.vue?vue&type=style&index=0&id=18ff1522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff1522",
  null
  
)

export default component.exports